import { Link } from 'react-router-dom';
import errorImage from '../../../assets/404.png';
import { handleClickToTop } from '../../components/Footer/Footer';

const ErrorPage: React.FC = () => {
    return (
        <>
            <div className='container_error'>
                <div className='error_page'>
                    <h1>Oops! Page Not Found</h1>
                    <div className='error_content'>
                        <img src={errorImage} alt="Error 404" className='error_image' />
                        <h2>The page you are looking for doesn't exist.</h2>
                        <Link to="/" onClick={handleClickToTop} className="back_home_link">Go Back to Homepage</Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ErrorPage;
